export default __webpack_public_path__ + "static/media/Edi2.372e53d6.svg";